import React from 'react';
import LocationTemplate from './LocationTemplate';

const MiddlesexPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Middlesex"
      stateName="North Carolina"
      countyName="Nash"
      zipCodes={["27557"]}
      latitude={35.7893}
      longitude={-78.2061}
      population={1149}
      historicalFact="Named after Middlesex County in England, incorporated in 1908."
      nearbyTowns={[
        "Nashville, NC",
        "Rocky Mount, NC",
        "Bailey, NC",
        "Wilson, NC",
        "Zebulon, NC",
        "Wendell, NC",
        "Wake Forest, NC",
        "Spring Hope, NC"
      ]}
    />
  );
};

export default MiddlesexPage;